import PivotGridColumnProps from './Columns'
import Vue from 'vue'

let KendoPivotGridColumn = {
    name: 'kendo-pivot-column',
    render () {
        return Vue.prototype._e
    },
    mixins: [PivotGridColumnProps]
}

export default KendoPivotGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotColumn/index.js